export default __webpack_public_path__ + "static/media/Recurso.3e28d4d9.png";